import { SelectionAny, SelectionChanged, SelectionReferenceNumber } from '../internal';
export class SelectionRecord extends SelectionAny {
    getReferenceNumber() {
        return this.get("REFN" /* Tag.Reference */, null, SelectionReferenceNumber);
    }
    getRecordIdentificationNumber() {
        return this.get("RIN" /* Tag.RecordIdNumber */);
    }
    getChanged() {
        return this.get("CHAN" /* Tag.Change */, null, SelectionChanged);
    }
}
//# sourceMappingURL=SelectionRecord.js.map